// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../../account/views/RedirectoLogin";
import { AppHeader } from "imagus-components";
import AdminUsers from "../containers/users/AdminUsers";
import Navbar from "../containers/Navbar";

class Users extends Component<*> {

  render(): * {
    return (
      <UserAuth principal='user-admin' unAuthChildren={<RedirectoLogin />} >
        <div className="app-main">
          <AppHeader
            title="Site Administration"
            IconName="SettingsApplications"
          />
          <Navbar router={this.props.router} />
          <AdminUsers />
        </div>
      </UserAuth>
    );
  }
}

export default Users;
